export default {
  primary: {
    blue: '#042F86',
    darkCyan: '#117AAA',
    cyan: '#30AEDF',
    green: '#14882C'
  },
  secondary: {
    softBlack: '#333333',
    lightCyan: '#EDFAFF',
    lightGray: '#F7F7F7'
  },
  indicator: {
    selectedState: "#105BFB",
    red: "#FC5350",
    yellow: "#F3D22F",
    lightGreen: "#56AC69"
  }
};